module.exports = __webpack_public_path__ + "img/icon_menu.ee8dbf34.png";